import { RootState } from 'src/store';

export const getSpgSlice = (state: RootState) => state?.spg;
export const getIsLoading = (state: RootState, widgetCode: string) =>
  state?.spg?.widgetData?.[widgetCode]?.isLoading;
export const getError = (state: RootState, widgetCode: string) =>
  state?.spg?.widgetData?.[widgetCode]?.error;
export const getWidgetData = (state: RootState, widgetCode: string) =>
  state?.spg?.widgetData?.[widgetCode];
export const getSpgWidgetDataForCode = (state: RootState, widgetCode: string) =>
  state?.spg?.widgetData?.[widgetCode]?.data;

export const getSelectedTileData = (state: RootState, widgetCode: string) =>
  state?.spg?.widgetData?.[widgetCode]?.selectedTileData;
